<template>
  <div class="terms-container">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-8-desktop is-10-tablet">
          <div class="card">
            <header class="card-header">
              <div class="card-header-title is-block">
                <h1
                  class="title is-spaced is-size-3-desktop is-size-4-mobileis-3 has-text-weight-bold mb-2"
                >
                  Términos y Condiciones
                </h1>
                <p
                  class="subtitle is-size-6-desktop is-size-6-mobile has-text-grey"
                >
                  Por favor, lee y acepta los términos antes de continuar con la
                  encuesta
                </p>
              </div>
            </header>

            <div class="card-content">
              <div class="scroll-area">
                <div class="content is-small">
                  Antes de comenzar, queremos contarte algunos puntos
                  importantes sobre tu participación en esta encuesta 📝
                  <br />
                  <h3 class="has-text-weight-semibold is-size-6">
                    1. Consentimiento Informado
                  </h3>
                  <p class="has-text-grey-dark">
                    Al responder, aceptas de forma voluntaria compartir
                    información que será utilizada por Siete S.A.S. con fines de
                    investigación. Todos los datos serán tratados con total
                    confidencialidad 🔒.
                  </p>

                  <h3 class="has-text-weight-semibold is-size-6">
                    2. Confidencialidad
                  </h3>
                  <p class="has-text-grey-dark">
                    Tu información será manejada de manera segura y anónima. En
                    ningún caso se compartirán datos personales con terceros sin
                    tu consentimiento.
                  </p>

                  <h3 class="has-text-weight-semibold is-size-6">
                    3. Uso de Datos
                  </h3>
                  <p class="has-text-grey-dark">
                    Los resultados se emplearán únicamente para los fines
                    descritos en esta encuesta. Los análisis y reportes se
                    presentarán por grupos donde participen cinco o más
                    personas, sin identificar ninguna respuesta individual 👥.
                  </p>

                  <h3 class="has-text-weight-semibold is-size-6">
                    4. Participación Voluntaria
                  </h3>
                  <p class="has-text-grey-dark">
                    💬 Tu participación es completamente voluntaria. Puedes
                    dejar la encuesta en cualquier momento, sin ninguna
                    consecuencia.
                  </p>

                  <h3 class="has-text-weight-semibold is-size-6">
                    5. Duración
                  </h3>
                  <p class="has-text-grey-dark">
                    Duración estimada ⏱️: Completar la encuesta tomará entre 15
                    y 20 minutos. Te recomendamos hacerlo en un momento
                    tranquilo, para que puedas responder con calma 🌿.
                  </p>

                  <h3 class="has-text-weight-semibold is-size-6">
                    6. Contacto
                  </h3>
                  <p class="has-text-grey-dark">
                    Si tienes preguntas o necesitas más información sobre esta
                    encuesta o el uso de tus datos, puedes escribirnos en
                    cualquier momento a nuestro correo de soporte:
                    <a href="mailto:mariae@sietegho.com">mariae@sietegho.com</a
                    >.
                  </p>
                </div>
              </div>
            </div>

            <footer class="card-footer">
              <div class="card-footer-item">
                <b-button
                  type="is-primary"
                  size="is-medium"
                  expanded
                  outlined
                  @click="() => handleAccept(false)"
                >
                  Rechazar y Finalizar
                </b-button>
                <b-button
                  type="is-primary"
                  size="is-medium"
                  expanded
                  @click="() => handleAccept(true)"
                >
                  Aceptar y Continuar
                </b-button>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsAndConditions",
  methods: {
    handleAccept(value) {
      this.$emit("accept", value);
    },
  },
};
</script>

<style scoped>
.terms-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background-color: #f5f5f5;
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-header-title {
  padding: 1.5rem;
}

.card-content {
  padding: 1.5rem;
}

.scroll-area {
  height: 400px;
  overflow-y: auto;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  padding: 1.5rem;
  background-color: #fafafa;
}

.content h3 {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}

.content h3:first-child {
  margin-top: 0;
}

.content p {
  margin-bottom: 1rem;
  line-height: 1.6;
}

.card-footer-item {
  padding: 1.5rem;
  display: flex;
  gap: 0.5rem;
}

/* Estilo para el scrollbar */
.scroll-area::-webkit-scrollbar {
  width: 8px;
}

.scroll-area::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.scroll-area::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.scroll-area::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/survey/TermsAndConditions.vue